export default __webpack_public_path__ + "static/media/Logonz-dark.3c426751.svg";